module.exports = __webpack_public_path__ + "static/media/boshidun1.9b664ce2.png";